import {
  jb_social_icons_css_default
} from "./chunk.VBICA3BC.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-social-icons/jb-social-icons.ts
var JbSocialIcons = class extends i {
  constructor() {
    super(...arguments);
    this.align = "center";
    this.ARIALABELS_DEFAULT = {
      bluesky: "BlueSky",
      facebook: "Facebook",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      mail: "Mail",
      x: "X",
      youtube: "YouTube"
    };
    this.items = void 0;
    this._renderedIcons = [];
  }
  connectedCallback() {
    super.connectedCallback();
    this._loadIcons().then();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("items")) {
      this._loadIcons().then();
    }
  }
  _clickSocialIcon(event, service, context) {
    this.dispatchEvent(
      new CustomEvent("jb-social-icons:clicked", {
        detail: { service, context },
        bubbles: true,
        composed: true
      })
    );
  }
  /**
   * Returns the corresponding social icon custom element based on the service name.
   * Dynamically imports the necessary icon component.
   */
  async _getSocialIcon(service) {
    switch (service) {
      case "bluesky":
        return `<jb-icon iconName="proprietary:bluesky"></jb-icon>`;
      case "email":
      case "mail":
        return `<jb-icon iconName="material:mail" weight="bold"></jb-icon>`;
      case "facebook":
        return `<jb-icon iconName="proprietary:facebook"></jb-icon>`;
      case "instagram":
        return `<jb-icon iconName="proprietary:instagram"></jb-icon>`;
      case "linkedin":
        return `<jb-icon iconName="proprietary:linkedin"></jb-icon>`;
      case "x":
        return `<jb-icon iconName="proprietary:x"></jb-icon>`;
      case "youtube":
        return `<jb-icon iconName="proprietary:youtube"></jb-icon>`;
      default:
        return "";
    }
  }
  async _loadIcons() {
    this._renderedIcons = await this._renderSocialIcons();
    this.requestUpdate();
  }
  /**
   * Maps each social icon option to a list item that contains an anchor element with the icon.
   */
  async _renderSocialIcons() {
    if (!this.items) return [];
    const isSingle = this.items.length === 1;
    const iconPromises = this.items.map(async (item) => {
      const iconHtml = await this._getSocialIcon(item.service);
      const anchor = document.createElement("jb-anchor");
      anchor.setAttribute("data-fly-padding", "0");
      anchor.link = item.link;
      anchor.innerHTML = iconHtml;
      anchor.classList.add("link");
      anchor.ariaLabels = item.ariaLabels ?? { label: this.ARIALABELS_DEFAULT[item.service] ?? A };
      return {
        anchor,
        service: item.service,
        item
      };
    });
    const loadedIcons = await Promise.all(iconPromises);
    return loadedIcons.map(
      ({ anchor, service, item }) => b`<li
          class="${service}"
          role="${isSingle ? "presentation" : A}"
          @click=${(e2) => this._clickSocialIcon(e2, service, item)}
        >
          ${anchor}
        </li>`
    );
  }
  render() {
    return b`
      <ul
        class="${e({ [this.align]: this.align !== "center" })}"
        role="${this.items?.length === 1 ? "presentation" : A}"
      >
        ${this._renderedIcons}
      </ul>
    `;
  }
};
JbSocialIcons.styles = [reset_css_default, jb_social_icons_css_default];
__decorateClass([
  n()
], JbSocialIcons.prototype, "align", 2);
__decorateClass([
  n({ type: Array })
], JbSocialIcons.prototype, "items", 2);
__decorateClass([
  r()
], JbSocialIcons.prototype, "_renderedIcons", 2);
JbSocialIcons = __decorateClass([
  customElement("jb-social-icons")
], JbSocialIcons);

export {
  JbSocialIcons
};
